import React from 'react';
import { Breakpoint } from '@noths/polaris-client-ribbons-base';
import { Responsive } from '@noths/polaris-client-ribbons-design-system';

import { ListingsControlsContainer } from '../ListingsControls/ListingsControlsContainer';
import * as styles from './ListingsControlsSideBar.styles';

export const ListingsControlsSideBar = () => (
  <div css={styles.listingsControlsSideBar}>
    <Responsive minBreakpoint={Breakpoint.L}>
      <ListingsControlsContainer />
    </Responsive>
  </div>
);
